import { LengthUnits } from "@/libs/units/length";
import { computeTubingLabel } from "@/models/equipment/tubings/properties";
import type { RenderScenarioExportCols } from "./sizingExportTypes";

export const renderYToolCols: RenderScenarioExportCols = ({
  scenario,
  calcs,
  targetUnits
}) => {
  // Get Y Tool - check uphole first, then downhole
  const equipment = scenario.equipment.value;
  const yTool =
    equipment?.r_uphole_y_tool || equipment?.r_downhole_y_tool || null;

  // Get bypass tubings - check uphole first, then downhole
  const bypassTubings =
    equipment?.r_xref_uphole_y_tool_bypass_tubings ||
    equipment?.r_xref_downhole_y_tool_bypass_tubings ||
    [];

  // Filter out deleted tubings and get the first one for display
  const validBypassTubings = bypassTubings.filter(
    tubing => tubing && !tubing.journal_deleted_at
  );
  const firstBypassTubing = validBypassTubings[0];

  // Format manufacturer and series/model
  const manufacturer = yTool?.manufacturer || "";
  const seriesModel = yTool?.series_model || "";
  const manufacturerSeriesModel =
    manufacturer && seriesModel
      ? `${manufacturer} ${seriesModel}`
      : manufacturer || seriesModel || "";

  // Get bypass tubing name based on unit system (matches casing/tubing sections)
  const bypassTubingName = computeTubingLabel(
    firstBypassTubing?.r_tubing,
    targetUnits.largeLengthUnit.label === "Meters"
  );

  return [
    {
      section: "Y Block",
      label: "Manufacturer Series/Model",
      targetUnit: null,
      value: manufacturerSeriesModel
    },
    {
      section: "Y Block",
      label: "Length",
      targetUnit: targetUnits.smallLengthUnit,
      value:
        yTool != null && yTool.length_inches != null
          ? LengthUnits.Inches.toStandardUnit(yTool.length_inches)
          : null
    },
    {
      section: "Y Block",
      label: "Width",
      targetUnit: targetUnits.smallLengthUnit,
      value:
        yTool != null && yTool.width_inches != null
          ? LengthUnits.Inches.toStandardUnit(yTool.width_inches)
          : null
    },
    {
      section: "Y Block",
      label: "Weight",
      targetUnit: targetUnits.massUnit,
      value:
        yTool != null && yTool.weight_pounds != null
          ? yTool.weight_pounds
          : null
    },
    {
      section: "Y Block",
      label: "Bypass Tubing",
      targetUnit: null,
      value: bypassTubingName
    },
    {
      section: "Y Block",
      label: "Bypass Tubing Length",
      targetUnit: targetUnits.largeLengthUnit,
      value:
        calcs.equipmentLengths.yToolBypassTubingLengthFt.value != null
          ? calcs.equipmentLengths.yToolBypassTubingLengthFt.value
          : null
    }
  ];
};
